module.exports = __webpack_public_path__ + "static/media/sort.76d00822.svg";